import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import './registerServiceWorker'

import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuetify from 'vuetify'
import GAuth from 'vue-google-oauth2'
import L from 'leaflet'

// Leaflet has a problem loading the marker urls
// https://github.com/PaulLeCam/react-leaflet/issues/255
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

// default axios' baseURL
axios.defaults.baseURL = process.env.VUE_APP_NOVA_API
// setup axios to be accessed via this.axios
Vue.use(VueAxios, axios)
Vue.prototype.$axios = axios

Vue.use(GAuth, {
  clientId: '1080910298495-i5v5q5d0melqfq0dol4emtbo8h35vhis.apps.googleusercontent.com', 
  scope: 'https://www.googleapis.com/auth/userinfo.email',
  prompt: 'select_account'
})

// vuetify setup
Vue.use(Vuetify, {
  theme: {
    primary: '#4f2984',         // purple
    accent: '#bbc746',          // green
    secondary: '#32bcad',       // teal
    info: '#a8acb1',            // grey
    warning: '#ef4123',         // red
    error: '#ef4123',           // red
    success: '#bbc756'          // green
  }
})

Vue.config.productionTip = false

import Muon from 'muon'
Vue.use(Muon)

import VuetifyDialog from 'vuetify-dialog'
Vue.use(VuetifyDialog)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
